import { z } from "zod";

const corporateEmailRegex = /^(?!.*(gmail|hotmail|yahoo)\.).*$/i;

export const vendorSignupSchema = z
  .object({
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter valid email address")
      .refine(
        (email) => corporateEmailRegex.test(email),
        "Please enter your corporate email address"
      ),
    firstName: z.string().min(1, "First Name is required"),
    lastName: z.string().min(1, "Last Name is required"),
    password: z.string().min(1, "Password is required"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Password do not match",
    path: ["confirmPassword"],
  });

export type VendorSignupFormData = z.infer<typeof vendorSignupSchema>;

export const defaultValues: VendorSignupFormData = {
  email: "",
  firstName: "",
  lastName: "",
  password: "",
  confirmPassword: "",
};

export const PAGE_CONFIG = {
  TITLE: "Create your account",
} as const;
